import { IUser } from "@/api";
import { Box, Paper, Typography, useMediaQuery, useTheme } from "@mui/material";

interface IProps {
    user: IUser;
}

export const HomePageHeader = ({ user }: IProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Paper variant="outlined">
            <Box px={2} py={2.5}>
                <Typography
                    variant={isMobile ? "h5" : "h4"}
                    color={theme.palette.primary.main}
                >
                    Welcome Back, {user.first_name}
                </Typography>
            </Box>
        </Paper>
    );
};
